import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { registerPWA, setupInstallPrompt } from './utils/pwa';
// === ANTI-BRANDING: Remove any injected third-party badges/watermarks ===
function removeBranding() {
  const brandingKeywords = ['lovable', 'made with', 'built with', 'powered by', 'created with', 'magicpatterns', 'magic patterns', 'vercel', 'netlify', 'hosted by', 'edit in', 'fork on', 'deployed with', 'generated by'];
  // Remove elements containing branding text
  const allElements = document.querySelectorAll('a, div, span, p, img, iframe, button, aside, section, footer');
  allElements.forEach(el => {
    const text = (el.textContent || '').toLowerCase();
    const href = (el as HTMLAnchorElement).href?.toLowerCase() || '';
    const src = (el as HTMLImageElement).src?.toLowerCase() || '';
    const id = el.id?.toLowerCase() || '';
    const className = el.className?.toString?.()?.toLowerCase() || '';
    const isBranding = brandingKeywords.some(kw => text.includes(kw) || href.includes(kw) || src.includes(kw) || id.includes(kw) || className.includes(kw));
    if (isBranding) {
      // Don't remove our own app elements
      const isOurApp = el.closest('[data-app="theo-edumarket"]') || el.closest('#root');
      if (!isOurApp || el.closest('body > :not(#root)')) {
        el.remove();
      }
    }
  });
  // Remove any fixed/absolute positioned elements outside #root (common badge pattern)
  document.querySelectorAll('body > *:not(#root):not(script):not(style):not(link):not(meta)').forEach(el => {
    const style = window.getComputedStyle(el);
    if (style.position === 'fixed' || style.position === 'absolute' || style.zIndex === '999' || style.zIndex === '9999' || style.zIndex === '99999' || parseInt(style.zIndex) > 900) {
      el.remove();
    }
  });
  // Remove iframes injected outside #root
  document.querySelectorAll('body > iframe, body > div > iframe').forEach(el => {
    if (!el.closest('#root')) {
      el.remove();
    }
  });
}
// Run on load
window.addEventListener('load', () => {
  removeBranding();
  // Run again after short delays (some badges inject late)
  setTimeout(removeBranding, 500);
  setTimeout(removeBranding, 1500);
  setTimeout(removeBranding, 3000);
  setTimeout(removeBranding, 5000);
});
// Continuously watch for injected elements
const observer = new MutationObserver(mutations => {
  let shouldClean = false;
  for (const mutation of mutations) {
    for (const node of Array.from(mutation.addedNodes)) {
      if (node instanceof HTMLElement && !node.closest('#root')) {
        shouldClean = true;
        break;
      }
    }
    if (shouldClean) break;
  }
  if (shouldClean) {
    requestAnimationFrame(removeBranding);
  }
});
observer.observe(document.body, {
  childList: true,
  subtree: true
});
// Initialize PWA
registerPWA();
setupInstallPrompt();
render(<App data-id="element-189" />, document.getElementById('root'));